export default "skymp5-front/5183d83cbcb7262bc8ce4325c6b83ab1.svg";